import gql from 'graphql-tag';

export const GET_NETWORK_LEGACY = gql`
  query NetworkLegacy($id: ID!, $territories: [Territory!]!) {
    networkLegacy(id: $id) {
      id
      altId
      name
      status
      territories
      publishers(territories: $territories) {
        id
        altId
        name
        status
        pricingType
        pricingAmount
        territories
      }
    }
  }
`;

export const GET_NETWORK_MINIMAL_LEGACY = gql`
  query NetworkMinimalLegacy($id: ID!) {
    networkLegacy(id: $id) {
      id
      name
      territories
    }
  }
`;

export const GET_ALL_NETWORKS_LEGACY = gql`
  query AllNetworksLegacy($territories: [Territory!]!) {
    allNetworksLegacy(territories: $territories) {
      id
      altId
      name
      status
      territories
    }
  }
`;
